import { ContentLayout, LeadForm, LeadFormIntegrated, TemplateWrapper } from "@2u-landing-pages/components";
import { ContentfulImageConfig } from "@2u-landing-pages/types";
import { Container } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";
import { FormProps } from "../../Form.types";
import styles from "./Default.module.scss";

interface CustomCSSProperties extends React.CSSProperties {
  "--progress-bar-color"?: string;
  "--question-color"?: string;
  "--button-background-color"?: string;
  "--button-text-color"?: string;
}

export const Default: React.FC<FormProps> = ({
  main_content,
  section_background_color,
  section_background_image,
  image_config,
  embedded,
  taxi_package_id,
  footnote,
  topSlot,
  progress_bar_color,
  question_color,
  button_background_color,
  button_text_color,
  button_hover_state,
  inDrawer,
  isLoading,
  thank_you_page_url,
  form_type
}) => {
  const style: CustomCSSProperties = {};

  if (progress_bar_color) style["--progress-bar-color"] = `var(${progress_bar_color})`;
  if (question_color) style["--question-color"] = `var(${question_color})`;
  if (button_background_color) style["--button-background-color"] = `var(${button_background_color})`;
  if (button_text_color) style["--button-text-color"] = `var(${button_text_color})`;

  const renderForm = () => {
    switch (form_type) {
      case "integrated-typ":
        return (
          <LeadFormIntegrated
            isLoading={isLoading}
            className={cn(styles[embedded ? "embeddedLeadForm" : "leadForm"], `btn-${button_hover_state || "dark"}`)}
            applyDomain={taxi_package_id}
            leadFormType="TY"
            footnote={footnote}
          />
        );
      case "integrated-plp":
        return (
          <LeadFormIntegrated
            isLoading={isLoading}
            className={cn(styles[embedded ? "embeddedLeadForm" : "leadForm"], `btn-${button_hover_state || "dark"}`)}
            packageId={taxi_package_id}
            thankYouURL={thank_you_page_url}
            leadFormType="LP"
            footnote={footnote}
          />
        );
      default:
        return (
          <LeadForm
            isLoading={isLoading}
            className={cn(styles[embedded ? "embeddedLeadForm" : "leadForm"], `btn-${button_hover_state || "dark"}`)}
            packageId={taxi_package_id}
            footnote={footnote}
          />
        );
    }
  };

  const formColumns = (
    <>
      <ContentLayout
        className={styles[embedded ? "embeddedContent" : "content"]}
        content={main_content}
        heading={{
          variant: embedded ? "heading-lg" : "heading-2xl",
        }}
        subhead={{
          variant: "subhead-sm",
        }}
      />
      {renderForm()}
    </>
  );
  if (embedded)
    return (
      <div className={styles.embeddedContainer} style={style}>
        {formColumns}
      </div>
    );

  return (
    <TemplateWrapper
      padded={!inDrawer}
      drawer={inDrawer}
      backgroundColor={section_background_color}
      backgroundImage={section_background_image}
      image_config={image_config as unknown as ContentfulImageConfig}
      style={style}
    >
      {topSlot}
      <Container>
        <Container
          flex
          direction="column"
          lg={{ direction: "row" }}
          className={cn(styles.formContainer, {
            [styles.formContainerInDrawer]: inDrawer,
          })}
        >
          {formColumns}
        </Container>
      </Container>
    </TemplateWrapper>
  );
};
